(() => {
  const body = document.body;
  const scrim = document.querySelector('.drawer-scrim');
  let activeDrawer = null;

  const shopRoot = window.Shopify?.routes?.root || '/';

  const trapFocus = (container) => {
    const focusable = container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (focusable.length) focusable[0].focus();
  };

  const closeDrawer = () => {
    if (!activeDrawer) return;
    activeDrawer.classList.remove('is-open');
    activeDrawer.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.hidden = true;
    body.classList.remove('drawer-open');
    activeDrawer = null;
  };

  const openDrawer = (name) => {
    const drawer = document.querySelector(`[data-drawer="${name}"]`);
    if (!drawer) return;
    closeDrawer();
    activeDrawer = drawer;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.hidden = false;
    body.classList.add('drawer-open');
    trapFocus(drawer);
  };

  const replaceThemeSection = (sectionName, html) => {
    if (!html) return;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const next = parsed.querySelector(`[data-theme-section="${sectionName}"]`);
    const current = document.querySelector(`[data-theme-section="${sectionName}"]`);
    if (next && current) current.replaceWith(next);
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-drawer-open]');
    if (openButton) {
      event.preventDefault();
      openDrawer(openButton.getAttribute('data-drawer-open'));
    }

    if (event.target.closest('[data-drawer-close]')) {
      event.preventDefault();
      closeDrawer();
    }

    const quantityButton = event.target.closest('[data-quantity-button]');
    if (quantityButton) {
      const wrapper = quantityButton.closest('[data-quantity]');
      const input = wrapper && wrapper.querySelector('input[type="number"]');
      if (!input) return;
      const step = quantityButton.getAttribute('data-quantity-button') === 'plus' ? 1 : -1;
      const min = Number(input.getAttribute('min') || 0);
      const nextValue = Math.max(min, Number(input.value || min) + step);
      input.value = nextValue;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const idInput = form.querySelector('input[name="id"]');
    const variantRadios = form.querySelectorAll('[data-variant-radio]');
    if (idInput && variantRadios.length) {
      variantRadios.forEach((radio) => {
        radio.addEventListener('change', () => {
          idInput.value = radio.value;
          const submit = form.querySelector('[type="submit"]');
          if (submit) {
            submit.disabled = radio.dataset.available === 'false';
            submit.querySelector('[data-add-text]').textContent = radio.dataset.available === 'false'
              ? window.themeStrings?.soldOut || 'Sold out'
              : window.themeStrings?.addToCart || 'Add to cart';
          }
        });
      });
    }

    form.addEventListener('submit', async (event) => {
      if (!window.fetch || form.dataset.noAjax === 'true') return;
      if (!document.querySelector('[data-theme-section="cart-drawer"]')) return;

      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      const formData = new FormData(form);
      formData.append('sections', 'cart-drawer,header');
      formData.append('sections_url', window.location.pathname);

      if (submit) submit.disabled = true;

      try {
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) throw new Error('Cart add failed');

        const state = await response.json();
        if (state.sections) {
          replaceThemeSection('cart-drawer', state.sections['cart-drawer']);
          replaceThemeSection('header', state.sections.header);
        }
        openDrawer('cart');
      } catch (error) {
        form.submit();
      } finally {
        if (submit) submit.disabled = false;
      }
    });
  });

  window.LEDDomainTheme = { openDrawer, closeDrawer };
})();
